var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { ref: "modal", attrs: { heading: "Withdraw Application" } },
    [
      _c(
        "form",
        {
          attrs: {
            action: "/candidate/job-applications/withdraw-application",
            method: "POST"
          }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          !_vm.confirmed
            ? _c("div", { staticClass: "mb-4" }, [
                _c("h5", [
                  _vm._v("Are you sure you want to withdraw your application?")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.confirmed
            ? _c("div", { staticClass: "mb-4" }, [
                _c("input", {
                  attrs: { type: "hidden", name: "job_application_id" },
                  domProps: { value: _vm.jobApplicationId }
                }),
                _vm._v(" "),
                _c("textarea", {
                  attrs: {
                    name: "reason",
                    rows: "5",
                    placeholder:
                      "Please provide a reason for withdrawing your application?"
                  },
                  domProps: { value: _vm.reason }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.confirmed
            ? _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button success btn-yes",
                      attrs: { type: "button" },
                      on: { click: _vm.confirm }
                    },
                    [_vm._v("Yes, remove my application")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button warning btn-no",
                      attrs: { type: "button" },
                      on: { click: _vm.toggleModal }
                    },
                    [_vm._v("No, please keep my application")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.confirmed
            ? _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
                _c("div", { staticClass: "cell shrink" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button success btn-yes",
                      attrs: { type: "submit" },
                      on: { click: _vm.submitReason }
                    },
                    [_vm._v("Submit")]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcbc2fa0", { render: render, staticRenderFns: staticRenderFns })
  }
}